import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

export const SiemNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="siem" />;
};
